import { render, staticRenderFns } from "./carSpace.vue?vue&type=template&id=556bdf88&scoped=true"
import script from "./carSpace.vue?vue&type=script&lang=js"
export * from "./carSpace.vue?vue&type=script&lang=js"
import style0 from "./carSpace.vue?vue&type=style&index=0&id=556bdf88&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556bdf88",
  null
  
)

export default component.exports